module.exports = __webpack_public_path__ + "img/document-pop.4c86c29.svg";